// [xleaders] XO-28: bốn màu chữ Zalo có (zca-js 2.1.2 `TextStyle`), mã cố định. Trong `content`
// markdown, màu ghi bằng link với scheme riêng `[chữ](zalo-color:db342e)` — markdown-it đã parse link
// sẵn nên bong bóng (MessageFormatter) và editor chỉ đổi token, còn `plainText` (danh sách hội thoại)
// tự bỏ URL giữ nhãn. Phía Ruby: app/services/zalo_personal/text_color.rb — hai bên phải cùng bảng.
export const ZALO_COLOR_SCHEME = 'zalo-color:';

export const ZALO_TEXT_COLORS = [
  { hex: 'db342e', title: 'Text color: red' },
  { hex: 'f27806', title: 'Text color: orange' },
  { hex: 'f7b503', title: 'Text color: yellow' },
  { hex: '15a85f', title: 'Text color: green' },
];

const HEXES = new Set(ZALO_TEXT_COLORS.map(color => color.hex));

export const zaloColorHref = hex => `${ZALO_COLOR_SCHEME}${hex}`;

// `zalo-color:db342e` → `db342e`; không phải link màu hoặc mã lạ → null (giữ như link thường).
export const zaloColorHex = href => {
  if (typeof href !== 'string' || !href.startsWith(ZALO_COLOR_SCHEME))
    return null;
  const hex = href.slice(ZALO_COLOR_SCHEME.length);
  return HEXES.has(hex) ? hex : null;
};

// Inline style thay vì class Tailwind: markup này sinh lúc render markdown (như `setImageSizing` của
// MessageFormatter), JIT của Tailwind không quét được, và toDOM của ProseMirror cần cùng một khuôn.
export const textColorStyle = hex => `color: #${hex}`;

// Đổi cặp token link có href màu thành `zalo_color_open/close` (tag span): renderer mặc định của
// markdown-it render span từ tag + attrs, còn parser ProseMirror map token này sang mark `textColor`.
const renameColorLinks = tokens => {
  const open = [];
  tokens.forEach(token => {
    if (token.type === 'link_open') {
      const hex = zaloColorHex(token.attrGet('href'));
      open.push(hex);
      if (!hex) return;
      token.type = 'zalo_color_open';
      token.tag = 'span';
      token.attrs = [['style', textColorStyle(hex)]];
      token.meta = { ...token.meta, color: hex };
    } else if (token.type === 'link_close' && open.pop()) {
      token.type = 'zalo_color_close';
      token.tag = 'span';
    }
  });
};

export default function zaloTextColorPlugin(md) {
  md.core.ruler.after('inline', 'zalo_text_color', state => {
    state.tokens.forEach(token => {
      if (token.type === 'inline') renameColorLinks(token.children);
    });
  });
}
